<template>
	<div class="binding-module">
		<el-col class="binding-item mb" v-for="(val, index) in dataList" :key="index">
			<client-module :moduletitle="val.title">
				<div class="redact" slot="event" v-if="val.hideBtn !== true">
					<template v-if="typeof val.btnName === 'object'">
						<el-button
							class="redact-btn"
							type="text"
							:disabled="btn.disabled"
							v-for="btn in val.btnName"
							@click="btn.btnClick"
							>{{ btn.name }}</el-button
						>
					</template>
					<el-button
						class="redact-btn"
						type="text"
						:disabled="val.disabled"
						v-else
						@click="val.btnClick"
						>{{ val.btnName }}</el-button
					>
					<el-tooltip effect="dark" :content="val.btnHint" placement="top-end" v-if="val.btnHint">
						<ig-icon name="tishi" class="redact-hint" :class="{ active: val.disabled }"></ig-icon>
					</el-tooltip>
				</div>
				<div calss="data-content">
					<div class="content-hint">
						<span v-if="val.hint">{{ val.hint }}</span>
					</div>
					<div v-if="val.layOutStyle">
						<el-row class="content-item-line" v-for="(item, idx) in val.datalist" :key="idx">
							<el-col :span="12">
								<div class="left_div">
									<span class="leftlabel">{{ item.leftlabel }}</span>
									<span
										class="value left_value"
										:class="{ active: item.leftvalue === '未绑定' || item.leftvalue === '未创建' }"
										>{{ item.leftvalue }}</span
									>
								</div>
							</el-col>
							<el-col :span="12">
								<div>
									<span class="label">{{ item.rightlabel }}</span>
									<span
										class="value"
										:class="{
											active: item.rightvalue === '未绑定' || item.rightvalue === '未创建',
										}"
										>{{ item.rightvalue }}</span
									>
								</div>
							</el-col>
						</el-row>
					</div>
					<div v-else>
						<div
							class="content-item"
							v-for="(item, idx) in val.datalist"
							:key="idx"
							:style="'height:' + val.height"
						>
							<p class="label">{{ item.label }}</p>
							<div
								class="value"
								:class="{ active: item.value === '未绑定' || item.value === '未创建' }"
							>
								<span>{{ item.value }}</span>
								<div class="data" v-if="item.data && item.value !== '未绑定'">
									{{ item.data }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</client-module>
		</el-col>
	</div>
</template>
<script>
import clientModule from '@/components/client/clientModule/clientModule';
export default {
	props: {
		dataList: {
			type: Array,
		},
	},
	data() {
		return {};
	},
	methods: {},
	components: { clientModule },
};
</script>
<style lang="scss">
.binding-module {
	display: grid;
	grid-template-columns: 50% 50%;

	.binding-item {
		font-size: 14px;

		.client-module {
			background-color: #fff;
			box-shadow: 0 4px 4px 0 rgba(67, 93, 255, 0.05);

			.module-main {
				width: 100%;
				padding: 15px 20px;

				.content-hint {
					font-size: 14px;
					color: #999;
					margin-bottom: 20px;

					.el-button {
						padding: 0;
					}
				}

				.content-item-line {
					display: flex;
					padding-bottom: 19px;

          .left_div {
            display: flex;
          }

					.leftlabel {
						display: inline-block;
						width: 120px;
						color: #999;
						text-align: right;
					}

					.left_value {
            flex: 1;
						overflow: hidden; //超出的文本隐藏
						text-overflow: ellipsis; //溢出用省略号显示
						white-space: nowrap; //溢出不换行
					}

					.label {
						display: inline-block;
						width: 170px;
						color: #999;
						text-align: right;
					}
				}

				.content-item {
					display: flex;
					margin: 20px 0;

					.label {
						width: 110px;
						color: #999;
						text-align: right;
					}
				}
			}

			.active {
				color: #999;
			}
		}

		.redact-btn {
			margin-right: 10px;
		}

		&.mb {
			margin-bottom: 20px;
		}

		&:nth-child(odd) {
			padding-right: 10px;
		}

		&:nth-child(even) {
			padding-left: 10px;
		}
	}

	.el-loading-spinner .circular {
		width: 20px;
	}

	.data {
		font-size: 12px;
		color: #7f7f7f;
		margin-top: 5px;
	}
}
</style>
